// src/components/SearchBar.js
import React, { useState } from 'react';
import { TextField, Button, Box } from '@mui/material';

const SearchBar = ({ onSearch }) => {
  const [address, setAddress] = useState('');

  const handleSearch = () => {
    onSearch(address);
    setAddress('');
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <Box display="flex" mb={2} mt={2}>
      <TextField
        label="Введите адрес"
        variant="outlined"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        onKeyPress={handleKeyPress}  // Добавляем обработчик нажатия клавиши
        fullWidth
      />
      <Button variant="contained" color="primary" onClick={handleSearch} sx={{ ml: 2 }}>
        Поиск
      </Button>
    </Box>
  );
};

export default SearchBar;
